export default __webpack_public_path__ + "static/media/SmallCTExcessiveMovementEdited.deb4e628.mp4";